import userflow from 'userflow.js'
import { FiltradorDeErros } from 'src/erros'
import { verificarSeEhEmailDeTeste } from 'src/utils/validadoras/validadoras'
import { obterSecret } from 'src/typescript/servicos/bifrost/bifrost.servico'

let userflowInicializado = false

export function obterIdiomaDoNavegadorParaUserflow (): string | undefined {
  if (typeof navigator === 'undefined') {
    return undefined
  }

  const idioma = navigator.languages?.[0] || navigator.language

  if (!idioma) {
    return undefined
  }

  if (typeof Intl === 'undefined' || typeof Intl.getCanonicalLocales !== 'function') {
    return idioma
  }

  try {
    return Intl.getCanonicalLocales(idioma)[0]
  } catch {
    return idioma
  }
}

export interface UsuarioUserFlow {
    idUsuario: string
    emailUsuario: string
    nomeUsuario: string
    papelUsuario:string
    idEmpresaUsuario:string
    nomeEmpresaUsuario:string
    tamanhoEmpresaUsuario: string
    canal: string
    dataCriacaoUsuario: string;
    lastLoginAt: string;
    currentLoginAt: string;
    modulosDisponiveis: {
      [key: string]: boolean;
    };
    servicosDisponiveis: {
      [key: string]: boolean;
    };
  }

  export function verificarSeUsuarioPermitidoUserFlow (): boolean {
    return true
}

export async function inicializarUserFlow () {

  if (userflowInicializado){
    return
  }

  // Sem token (ambiente local sem o secret), inicializar lançaria
  // UserflowError fora deste try/catch, no async interno da biblioteca.
  const token = obterSecret('USERFLOW_API_KEY')
  if (!token) {
    return
  }

  try {
    userflow.init(token)
    userflowInicializado = true
  } catch (erro) {
    FiltradorDeErros.capturarErro(erro as Error)
    userflowInicializado = false
  }
}

export function validarUsuarioUserFlow (usuario: UsuarioUserFlow , mostrarUserFlow: boolean = false, ignorarFiltros: boolean = false) {
  const usuarioUserFlowTratado = montarUsuarioUserFlowTratado(usuario)

  if (ignorarFiltros) {
    return true
  }

  const primeiroLogin = usuarioUserFlowTratado.primeiroLogin
  const emailValido = !verificarSeEhEmailDeTeste(usuarioUserFlowTratado.email)

  const inicializarUserFlow = mostrarUserFlow && primeiroLogin && emailValido
  return inicializarUserFlow
}

export function montarUsuarioUserFlowTratado (usuario: UsuarioUserFlow) {

  const { modulosDisponiveis, servicosDisponiveis, ...usuarioSemModulos } = usuario;

  function primeiroLogin(usuario: any) {
    if (usuario.lastLoginAt === null && usuario.semanasUsoUsuario < 2) {
      return true
    }

    return false
  }

  const usuarioUserFlowTratado = {
    ...usuarioSemModulos,
    ...modulosDisponiveis,
    ...servicosDisponiveis,
    loginAtual: usuario.currentLoginAt,
    ultimoLogin: usuario.lastLoginAt,
    primeiroLogin: primeiroLogin(usuario),
    email: usuario.emailUsuario,
    name: usuario.nomeUsuario,
    signed_up_at: usuario.dataCriacaoUsuario,
    locale_code: obterIdiomaDoNavegadorParaUserflow()
  }

  return usuarioUserFlowTratado
}

export async function identificarUsuarioUserFlow (usuario: UsuarioUserFlow) {
  const usuarioUserFlowTratado = montarUsuarioUserFlowTratado(usuario)
  try {
    userflow.identify(
      usuario.idUsuario, usuarioUserFlowTratado
    )
  } catch (erro) {
    FiltradorDeErros.capturarErro(erro as Error)
  }
}

export async function iniciarTourUserflowManualmente(tourId: string) {
  try {
    if(!tourId){
      return;
    }

    await userflow.start(tourId)
  } catch (erro) {
    FiltradorDeErros.capturarErro(erro as Error)
  }
}

export function resetarUserFlow () {
  try {
    if (userflow && userflow.isIdentified()) {
      userflow.reset()
    }

    userflowInicializado = false
  } catch (erro) {
    FiltradorDeErros.capturarErro(erro as Error)
  }
}
